module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MakeSameHeight_16"],"path":[{"$":{"d":"M7,10V6H5.17l3-3,3,3H9v4h2.17l-3,3-3-3ZM1,16H15V14H1ZM1,0V2H15V0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MakeSameHeight_16.svg
// module id = +ah4
// module chunks = 1